import { render, staticRenderFns } from "./resume_manage_detail.vue?vue&type=template&id=12a67f8e&scoped=true"
import script from "./resume_manage_detail.vue?vue&type=script&lang=js"
export * from "./resume_manage_detail.vue?vue&type=script&lang=js"
import style0 from "./resume_manage_detail.vue?vue&type=style&index=0&id=12a67f8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a67f8e",
  null
  
)

export default component.exports